import styled from 'styled-components';

// constants
const SIZE = `80px`;

const Limit = styled.div`
  width: ${SIZE};
  max-width: ${SIZE};
  min-width: ${SIZE};
`;

export default Limit;
